import React from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import LogoWhite from "../../assets/kyahrayne-1c-tm-white-cropped.png";
import {
  INSTAGRAM_URL,
  FACEBOOK_URL,
  LINKEDIN_URL,
  TWITTER_URL
} from "../../constants";
import { useCustomRouter } from "../../hooks/useCustomRouter";
import {
  StyledFooter,
  Inner,
  LogoImg,
  Tagline,
  EINText,
  SocialRow,
  SocialLink,
  ColHeading,
  NavLinkList,
  NavLinkItem,
  StayText,
  EmailForm,
  EmailInput,
  SubscribeButton,
  ContactLine
} from "./styled.components";

const quickLinks: { label: string; path?: string }[] = [
  { label: "About Us", path: "about-us" },
  { label: "Our Story", path: "about-us/kyahs-story" },
  { label: "Our Team", path: "about-us/our-team" },
  { label: "Collaborators", path: "about-us/collaborators" },
  { label: "News & Media", path: "about-us/in-the-news" },
  { label: "Contact Us", path: "about-us/our-team" }
];

const programs = [
  {
    label: "EPICourse: AZ Schools",
    path: "trainings/kyahs-epicourse-for-arizona-schools"
  },
  {
    label: "National EPICourse",
    path: "trainings/kyahs-epicourse-for-schools"
  },
  {
    label: "Food Service EPICourse",
    path: "trainings/kyahs-epicourse-for-food-service"
  }
];

const Footer: React.FC = () => {
  const customRouter = useCustomRouter();
  return (
    <StyledFooter>
      <Inner>
        <div>
          <LogoImg src={LogoWhite} alt="Kyah Rayne Foundation" />
          <Tagline>
            Saving lives through food allergy education, emergency preparedness,
            and public health partnerships.
          </Tagline>
          <EINText>
            <strong>EIN:</strong> 87-1903581
          </EINText>
          <SocialRow>
            <SocialLink
              href={FACEBOOK_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </SocialLink>
            <SocialLink
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </SocialLink>
            <SocialLink
              href={LINKEDIN_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedinIn />
            </SocialLink>
            <SocialLink
              href={TWITTER_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaXTwitter />
            </SocialLink>
          </SocialRow>
        </div>

        <div>
          <ColHeading>Quick Links</ColHeading>
          <NavLinkList>
            {quickLinks.map(l => (
              <NavLinkItem key={l.label}>
                <button
                  onClick={
                    l.path ? () => customRouter.push("/" + l.path!) : undefined
                  }
                  disabled={!l.path}
                >
                  {l.label}
                </button>
              </NavLinkItem>
            ))}
          </NavLinkList>
        </div>

        <div>
          <ColHeading>Programs</ColHeading>
          <NavLinkList>
            {programs.map(p => (
              <NavLinkItem key={p.label}>
                <button onClick={() => customRouter.push("/" + p.path)}>
                  {p.label}
                </button>
              </NavLinkItem>
            ))}
          </NavLinkList>
        </div>

        <div>
          <ColHeading>Stay Connected</ColHeading>
          <StayText>
            Sign up for updates, news, and training opportunities.
          </StayText>
          <EmailForm
            action="https://kyahraynefoundation.us1.list-manage.com/subscribe/post?u=69716092fda5b8ecfebe0494e&id=ff12db3551&f_id=00e0dee4f0"
            method="post"
            target="_blank"
          >
            <EmailInput />
            <input type="hidden" name="tags" value="6334330" />
            <div
              aria-hidden="true"
              style={{ position: "absolute", left: "-5000px" }}
            >
              <input
                type="text"
                name="b_69716092fda5b8ecfebe0494e_ff12db3551"
                tabIndex={-1}
                defaultValue=""
              />
            </div>
            <SubscribeButton>Subscribe</SubscribeButton>
          </EmailForm>
          <ColHeading>Contact</ColHeading>
          <ContactLine>3104 E. Camelback Rd., Ste. 1172</ContactLine>
          <ContactLine>Phoenix, AZ 85016</ContactLine>
          <ContactLine>(480) 520-5924</ContactLine>
          <ContactLine>outreach@kyahraynefoundation.org</ContactLine>
        </div>
      </Inner>
    </StyledFooter>
  );
};

export default Footer;
